import { Container, Markdown, SectionTitle } from '@sloyd/ui';
import { markdown } from './ContentApi.md.js';
import { Wrapper } from './ContentApi.style.js';

export type ContentApiProps = {};

export function ContentApi(_props: ContentApiProps) {
  return (
    <Wrapper className='ContentApi-wrapper' data-testid='ContentApi-wrapper'>
      <SectionTitle gradient={{ from: '#ff6a00', to: '#ee0979' }} title='API'>
        Integrate Sloyd into your projects with our <strong>API</strong>.
      </SectionTitle>
      <Container>
        <Markdown mode='dark' markdown={markdown} />{' '}
      </Container>
    </Wrapper>
  );
}

export default ContentApi;
